import {
  Button,
  IconQuestionmark,
  Stack,
} from '@adc/parallax-component-library';
import { useNavigate } from '@tanstack/react-router';

import { useNavigationItems } from '~/hooks/useNavigationItems';
import { buildTestId } from '~/utils/buildTestId';

import { NavigationItem } from './NavigationItem';

const TEST_ID = 'navigation' as const;

export const NavigationMenu = () => {
  const navigate = useNavigate();
  const { navigationItems } = useNavigationItems();

  const navigateToCustomerSupport = async () => {
    await navigate({ to: '/support' });
  };

  return navigationItems.length > 0 ? (
    <Stack
      width={300}
      backgroundColor="$neutral.20"
      paddingBottom="$4"
      testID={TEST_ID}
    >
      <Stack
        flex={1}
        padding="$4"
        testID={buildTestId({
          testID: TEST_ID,
          suffix: 'menu',
        })}
      >
        {navigationItems.map(
          ({ id, icon, label, path, testID: itemTestID }, index) => (
            <NavigationItem
              key={`${id}-${index}`}
              label={label}
              icon={icon}
              path={path}
              testID={buildTestId({
                testID: TEST_ID,
                suffix: itemTestID,
              })}
            />
          ),
        )}
      </Stack>

      <Stack>
        <Button
          label="Customer Support"
          variant="tertiary"
          theme="Neutral"
          size="small"
          iconEnd={<IconQuestionmark />}
          onPress={() => void navigateToCustomerSupport()}
          margin="$3"
          // @ts-expect-error Parallax doesnt expose "justifyContent" prop type
          justifyContent="space-between"
          testID={buildTestId({
            testID: TEST_ID,
            suffix: 'support',
          })}
        />
      </Stack>
    </Stack>
  ) : null;
};
